import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { RoleType } from '../../utils/jwtUtils'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'
import { ApiError } from '../../types/exception/errorStatus'

export function useUpdateRoles() {
  const { t } = useTranslation(['users', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { putter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updateRoles = async (profileId: number, roleTypeList: RoleType[]) => {
    setLoading(true)

    try {
      const data = await putter<RoleType[]>(
        `${CONFIG.BOUNCE_API}/api/v1/profiles/${profileId}/roles`,
        roleTypeList,
        'application/json'
      )
      if (data) {
        setError(null)
        setSuccess(t('users:users.success.roles-updated'))
        return data
      }
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { updateRoles, loading, success, error, resetState }
}
